export const setMetadata = (data) => {
  return {
    type: 'SET_METADATA',
    data,
  }

}
